import React from "react";

interface HeaderBadgeProps {
  count: number;
  /** "red" (default) for an alert count, "blue" for a neutral one (the cart). */
  tone?: "red" | "blue";
  /** Read by screen readers — the visible digits alone ("10+") say nothing. */
  label?: string;
}

/**
 * The one badge every header icon (bell, unsigned files, cart) renders its
 * count with. Before this component each spot had its own 16px circle with
 * 12px text, so two digits never fit — "10+" rendered as a clipped "0+".
 * 18px plus a white ring keeps the badge legible against the white header
 * and readable over whatever icon color sits behind it.
 */
const HeaderBadge: React.FC<HeaderBadgeProps> = ({ count, tone = "red", label }) => {
  if (count <= 0) return null;
  const toneClass = tone === "blue" ? "bg-blue-600" : "bg-red-600";
  return (
    <span
      aria-label={label}
      className={`absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full ring-2 ring-white text-white text-[10px] font-bold leading-none tabular-nums flex items-center justify-center ${toneClass}`}
    >
      {count > 99 ? "99+" : count}
    </span>
  );
};

export default HeaderBadge;
